
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.31 20.27a.496.496 0 01-.5-.5v-1.209a2.6 2.6 0 011.018-2.073c1.863-1.46 3.763-2.4 4.167-2.612.057-.019.076-.076.076-.134V12.59c-.307-.5-.46-1.075-.537-1.575-.173-.019-.404-.269-.653-1.152-.346-1.21.02-1.382.326-1.363a3.04 3.04 0 01-.076-1.843c.153-.672.518-1.23.94-1.652.27-.268.557-.518.864-.71.25-.173.538-.326.845-.422.23-.077.5-.135.768-.154.845-.077 1.479.135 1.92.403.672.384.941.864.941.864s1.709.115.96 3.706c.23.077.384.403.134 1.344-.326 1.152-.633 1.229-.806 1.094a5.177 5.177 0 01-.384 1.248v1.325a4.956 4.956 0 00-.825 2.727 4.96 4.96 0 001.785 3.801H3.31v.039zm17.894-3.782a3.81 3.81 0 01-3.802 3.801 3.81 3.81 0 01-3.801-3.802 3.81 3.81 0 013.801-3.801 3.786 3.786 0 013.802 3.802zm-4.32-1.498c0 .269.211.48.48.48s.48-.211.48-.48-.23-.48-.499-.48c-.25 0-.46.211-.46.48zm1.171 2.822h-.23v-1.9h-1.056v.633H17v1.286h-.23v.634h1.286v-.653z","fill":"#202A21"}})])
          )
        }
      }
    